import React from 'react'
import { I18n } from 'react-redux-i18n'
import { useSelector } from 'react-redux'

import { URL_CONSTANTS } from '../../../constants'
const MAP_EMBED = URL_CONSTANTS.mapEmbed

/**
 * Embed map
 * @param {object} props
 * @param {object} props.location
 * @param {number} props.location.lat
 * @param {number} props.location.lon
 * @param {string} [props.location.address]
 * @param {string} [props.location.label]
 * @param {string} [props.className]
 * @param {boolean} [props.hiddenAddress=false]
 * @param {number} [props.width=420] iframe width
 * @param {number} [props.height=300] iframe height
 */
const MapEmbed = (props) => {
  const { className = '', location, hiddenAddress = false, width = 420, height = 300 } = props

  // Operator locale from redux
  const operatorLocale = useSelector((store) => store.user.locale || 'es')

  // Complete address
  let address =
    !location.label || ['my_location', 'pinned_location'].includes(location.label) ? I18n.t(location.label || 'pinned_location') : location.label

  if (location.address) address += `${address ? ', ' : ''}${location.address}`

  const coordinateText = `${location.lat},${location.lon}`

  let url = `${MAP_EMBED}&language=${operatorLocale}&q=${location.address ? address : coordinateText}`

  return (
    <div className={`map_embed ${className}`}>
      {hiddenAddress ? null : (
        <p className='mt-1'>
          <b>{I18n.t('dashboard_address')}:</b> {address}
        </p>
      )}

      <iframe
        title={address || coordinateText}
        width={width}
        height={height}
        frameBorder='0'
        referrerPolicy="no-referrer-when-downgrade"
        style={{ border: 0 }}
        src={url}
        allowFullScreen
      ></iframe>
    </div>
  )
}

export default MapEmbed
